import {BarsOutlined} from '@ant-design/icons';
import {Flex, Radio} from 'antd';
import React from 'react';

import {ReactComponent as ToggleMap} from '../../assets/mapBlack.svg';

const ListViewMapViewToggle: React.FC<{
  setIsListView: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({setIsListView}) => {
  return (
    <Radio.Group
      buttonStyle="solid"
      className="toggleListMapView"
      defaultValue={true}
    >
      <Radio.Button
        onClick={() => {
          setIsListView(true);
        }}
        value={true}
        className="radioButton1"
      >
        <Flex align="center" justify="space-between" gap="8px">
          <BarsOutlined size={13} />
          <div>List View</div>
        </Flex>
      </Radio.Button>
      <Radio.Button
        onClick={() => {
          setIsListView(false);
        }}
        value={false}
        className="radioButton2"
      >
        <Flex align="center" justify="space-between" gap="8px">
          <ToggleMap size={13} />
          <div>Map View</div>
        </Flex>
      </Radio.Button>
    </Radio.Group>
  );
};

export default ListViewMapViewToggle;
